import { DragEvent, useRef } from "react";
import "./styles.scss";

import clsx from "clsx";
import { Button } from "components";
import { FileInputProps } from "./types";

function preventDefaultHandler(evt: DragEvent) {
	evt.preventDefault();
}

export default function FileInput({
	name,
	handleDrop,
	handleInputChange,
	disabled,
	required,
	children,
	wrapperClassName,
	buttonClassName,
	buttonChildrenClassName,
	buttonHierarchy = "secondary",
	multiple,
	buttonId
}: Readonly<FileInputProps>): JSX.Element {
	const inputRef = useRef<HTMLInputElement | null>(null);

	return (
		<div className={clsx("flex flex-row items-center gap-3", wrapperClassName)}>
			<Button
				className={clsx("flex gap-2 w-full", buttonClassName)}
				type="button"
				hierarchy={buttonHierarchy}
				onClick={() => {
					inputRef.current?.click();
				}}
				onDragOver={preventDefaultHandler}
				onDrop={handleDrop}
				disabled={disabled}
				childrenWrapperClassName={buttonChildrenClassName}
				id={buttonId}
			>
				{children}
			</Button>
			<input
				name={name}
				ref={inputRef}
				type="file"
				multiple={multiple}
				value=""
				onChange={handleInputChange}
				disabled={disabled}
				required={required}
				hidden
			/>
		</div>
	);
}
